<template>
  <div
    class="px-4 py-2 font-medium text-xss uppercase first-of-type:border-t-0 border-y border-outline first-of-type:mt-0 mt-2"
  >
    <slot />
  </div>
</template>
